import axios from 'axios';

export const quotationService = {
	listQuotations,
    acceptQuotation
};

function listQuotations() {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/project/", {params: {q: "quotation"}});
}

function acceptQuotation(projectId, accepted){
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	let body = {'acceptQuotation': accepted}
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/project/"+projectId+"/accept-quotation-odoo/", body, headers);
}